var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.5,7l-0.4-1.1c-0.1-0.2,0-0.5,0.1-0.7C15.4,5.1,15.7,5,15.9,5l1.8,0.1l0,0.9L16.2,6l0.3,0.8L15.5,7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19,15.3c-0.1,0-0.2,0-0.2-0.2l-3-8.1c0,0,0-0.1,0-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.2,0.2l3,8.1 c0,0,0,0.1,0,0.2C19.2,15.2,19.2,15.3,19,15.3C19.1,15.3,19,15.3,19,15.3z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9,15.4c0,0-0.1,0-0.1,0c-0.1-0.1-0.2-0.3-0.1-0.4l3.8-6.6c0.1-0.1,0.3-0.2,0.4-0.1C9,8.4,9.1,8.6,9,8.7 l-3.8,6.6C5.1,15.4,5,15.4,4.9,15.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,15.4C10.4,15.4,10.4,15.4,10.5,15.4c-0.2,0-0.3-0.1-0.3-0.2L8.4,8.6c0-0.1,0-0.2,0-0.3 c0-0.1,0.1-0.1,0.2-0.1h7.8c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3H9.1l1.5,5.8L16.6,9c0.1-0.1,0.3-0.1,0.4,0 c0.1,0.1,0.1,0.3,0,0.4l-6.3,6C10.6,15.4,10.5,15.4,10.5,15.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.2,15.1c0,0.4,0.4,0.8,0.8,0.8c0.4,0,0.8-0.4,0.8-0.8c0-0.4-0.4-0.8-0.8-0.8C18.6,14.3,18.2,14.7,18.2,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.2,15.1c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8c0-0.4-0.4-0.8-0.8-0.8S4.2,14.7,4.2,15.1z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,8.8c-0.2,0-0.3-0.1-0.3-0.3V7.1c0-0.2,0.1-0.3,0.3-0.3C8.9,6.8,9,6.9,9,7.1v1.4C9,8.7,8.9,8.8,8.7,8.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,10.3l-1.3-3.4c0-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.2,0.2-0.2,0.4l1.3,3.5C17.2,10.4,17.4,10.3,17.5,10.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.9,11.1c-2.2,0-3.9,1.8-3.9,4C1,17.2,2.8,19,4.9,19s3.9-1.8,3.9-3.9C8.9,12.9,7.1,11.1,4.9,11.1z M4.9,18.2 c-1.7,0-3.1-1.4-3.1-3.1S3.2,12,4.9,12S8,13.4,8,15.1C8.1,16.8,6.7,18.2,4.9,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.1,11.1c-2.2,0-3.9,1.8-3.9,3.9s1.8,3.9,3.9,3.9S23,17.2,23,15S21.2,11.1,19.1,11.1z M19.1,18.2c-1.7,0-3.1-1.4-3.1-3.1 s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C22.2,16.8,20.8,18.2,19.1,18.2z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,8.8c-0.2,0-0.3-0.1-0.3-0.3V7.1c0-0.2,0.1-0.3,0.3-0.3C8.9,6.8,9,6.9,9,7.1v1.4C9,8.7,8.9,8.8,8.7,8.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.9,17.3c-0.1,0-0.2,0-0.2-0.1l-0.5-1.9c0-0.1,0-0.2,0.1-0.3c0.1,0,0.2,0,0.3,0.1l0.5,1.9C11.2,17.1,11.1,17.2,10.9,17.3 C11,17.3,11,17.3,10.9,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.6,16.7L10.2,17c-0.2,0-0.3,0.2-0.2,0.4l0,0c0,0.2,0.2,0.3,0.4,0.2l1.3-0.4c0.2,0,0.3-0.2,0.2-0.4l0,0 C11.9,16.7,11.7,16.6,11.6,16.7z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,7L15.4,7c0-0.1,0-0.3,0.2-0.3l0.6-0.2c0.1,0,0.3,0,0.3,0.2l0,0c0,0.1,0,0.3-0.2,0.3l-0.6,0.2 C15.6,7.2,15.4,7.1,15.4,7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7,10.5L16.7,10.5c0-0.1,0-0.3,0.2-0.3l0.6-0.2c0.1,0,0.3,0,0.3,0.2l0,0c0,0.1,0,0.3-0.2,0.3L17,10.7 C16.9,10.7,16.8,10.6,16.7,10.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M6.5,6.5C6.4,6.3,6.6,6,6.9,6.1c0.3,0.1,0.7,0.2,1.3,0.2h0.1h0.5l1.6,0c0,0,0.1,0,0.1,0c0.2,0.1,0.4,0.6,0.4,0.6H9.9 C9.4,6.9,9.1,7,8.9,7.2c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1C7.4,7.6,6.5,6.5,6.5,6.5L6.5,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.fee25caf2a45fd7e2580d9bd25a93162.svg";
export { ForwardRef as ReactComponent };